import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Phone, MapPin } from "lucide-react";
import { companyInfo, navigation } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-[#0D2B21] text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <span className="font-black text-lg tracking-tight text-white">FICHET</span>
              <div className="w-8 h-8 bg-[#C9A227] flex items-center justify-center">
                <span className="font-black text-base text-black">S</span>
              </div>
              <span className="font-semibold text-xs text-gray-300 tracking-[0.2em] uppercase">Serrurerie</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Serrurier spécialiste des serrures et portes Fichet depuis plus de 10 ans.
              Dépannage, ouverture et remplacement de cylindres à Paris et en Île-de-France.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" aria-label="Facebook" className="text-gray-400 hover:text-[#C9A227] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Instagram" className="text-gray-400 hover:text-[#C9A227] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Youtube" className="text-gray-400 hover:text-[#C9A227] transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-white mb-5 tracking-tight">Nos services</h4>
            <ul className="space-y-3">
              {navigation.slice(1).map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-400 hover:text-[#C9A227] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-5 tracking-tight">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5 text-[#C9A227] flex-shrink-0" />
                <span>Dépannage express — Paris et Île-de-France</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <Phone className="w-4 h-4 text-[#C9A227] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
            </ul>
          </div>

          {/* Urgence */}
          <div>
            <h4 className="font-bold text-white mb-5 tracking-tight">Urgence 24/7</h4>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Une intervention en urgence ? Nos techniciens spécialistes Fichet sont disponibles jour et nuit.
            </p>
            <a
              href={`tel:${companyInfo.emergencyPhone.replace(/\s/g, "")}`}
              className="inline-flex items-center gap-2 bg-[#C9A227] text-black font-bold px-5 py-3 hover:bg-[#A8861C] transition-colors"
            >
              <Phone className="w-4 h-4" />
              {companyInfo.emergencyPhone}
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-sm text-gray-400 leading-relaxed bg-white/5 border border-white/10 p-4 mb-8" data-testid="independence-disclaimer">
            ⚠️ <strong className="text-white">Entreprise indépendante</strong> spécialisée dans le dépannage et l'entretien des serrures Fichet.
            Nous ne sommes pas affiliés au groupe Fichet ni au réseau officiel Point Fort Fichet.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
            <p>© {new Date().getFullYear()} Fichet Serrurerie. Tous droits réservés.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
              <a href="#" className="hover:text-white transition-colors">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
